import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, withRouter } from "react-router";
import { Link } from 'react-router-dom';
import queryString from 'query-string'
import * as actions from '../../../../../store/actions';
import jwt_decode from "jwt-decode";

import { Spinner } from 'react-bootstrap'
import FieldInput from '../../../../../components/FieldInput/FieldInput';
import Button from '../../../../../components/Button/Button';
import SweetAlert from 'react-bootstrap-sweetalert';

const NewPassword = (props) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  let [isLoading, setLoading] = useState(false)
  const [isData, setData] = useState({
    token: null,
    password: '',
    confirm_password: ''
  });
  const [disabled, setDisabled] = useState(false)

  const [isAlert, setAlert] = useState(false);

  const onSubmit = (data) => {
    dispatch(actions.submitPasswordRecovery(data))
    setInterval(() => {
      setLoading(false)
    }, 500)
  };

  const submitHandler = event => {
    event.preventDefault();
    setLoading(true)
    onSubmit(isData);
  };

  const response = useSelector(state => state.user.authResponse)
  let query = queryString.parse(props.location.search)
  const [isErrors, setErrors] = useState(null)
  useEffect(() => {
    if (response) {
      setErrors(response.errors)
      if (response.success) {
        setAlert(true)
      }
    }
  }, [response] )

  useEffect(() => {
    if(isData.password === isData.confirm_password){
      setErrors(null)
      setDisabled(false)
    }
    else{
      const timer = setTimeout(() => {
        setErrors({
          password: 'password is not match'
        })
        setDisabled(true)
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [isData])

  const checkToken = (token) => {
    let result = true;
    try {
      let decodedToken = jwt_decode(token);
      let currentDate = new Date();
      if (decodedToken.exp * 1000 < currentDate.getTime()) {
        result = false;
      }
    } catch (err) {
      result = false;
    }

    return result;
  }

  if (query.token && checkToken(query.token)) {
    if (!isData.token) {
      setData({ ...isData, token: query.token })
    }
    return (
      <form className='login__form' onSubmit={submitHandler}>
        <FieldInput
          login
          placeholder='Input new password'
          value={isData.password}
          inputHandler={() => e => setData({ ...isData, password: e.target.value })}
          type={'password'}
        />
        <FieldInput
          login
          placeholder='Confirm new password'
          value={isData.confirm_password}
          inputHandler={() => e => setData({ ...isData, confirm_password: e.target.value })}
          type={'password'}
        />
        { isErrors && isErrors.password ? <small className="text-danger ml-3">{isErrors.password}</small> : null }
        <div className='login__details align-items-center'>
          <Button disabled={disabled} inputType='submit' size='small'>
            {
              isLoading ?
                <span>
                  <Spinner size="small" className="mr-2" animation="border" role="status" />
                </span>
                : 'Save'
            }
          </Button>
          <Link to='/login'>{t('general.backTo')} Login</Link>
        </div>
        <div className="text-center">
          { isErrors && isErrors.token ? <small className="text-danger">Error: {isErrors.token}</small> : null }
        </div>
        <SweetAlert
          type="success"
          title={t('general.success')}
          show={isAlert}
          onConfirm={() => props.history.push('/login')}
        >
          {t('login.setPasswordSuccess')}
        </SweetAlert>
      </form>
    );
  } else {
    return(<Redirect to="/" />)
  }



};

export default withRouter(NewPassword);
